export default __webpack_public_path__ + "static/media/add_more.e843cc45.svg";